import type { Data } from '@repo/strapi'
import AppLink from '@/components/elementary/AppLink'

interface SeoNavigationFallbackProps {
	navbarItems?: Data.Component<'layout-utilities.navbar-item'>[] | null
	logInLink?: Data.Component<'utilities.link'> | null
	primaryButtons?: Data.Component<'utilities.link'>[] | null
	dropdownItem?: Data.Component<'layout-utilities.dropdown-item'> | null
}

export function SeoNavigationFallback({
	navbarItems,
	logInLink,
	primaryButtons,
	dropdownItem,
}: SeoNavigationFallbackProps) {
	return (
		<nav className="sr-only" aria-label="Main navigation">
			<ul>
				{Array.isArray(navbarItems) &&
					navbarItems.map((item) => (
						<li key={item.id}>
							{item.href ? (
								<AppLink href={item.href} openExternalInNewTab={item.newTab ?? false} tabIndex={-1}>
									{item.label}
								</AppLink>
							) : (
								<span>{item.label}</span>
							)}

							{/* Render dropdown items as nested links for SEO */}
							{(item.categoryCards || item.featuredCards) && (
								<ul>
									{item.categoryCards?.map((categoryCard) =>
										categoryCard?.column?.map((oneColumn) =>
											oneColumn.links?.map((link) =>
												link.href ? (
													<li key={link.id}>
														<AppLink
															href={link.href}
															openExternalInNewTab={link.newTab ?? false}
															tabIndex={-1}
														>
															{link.title ?? link.subTitle}
														</AppLink>
													</li>
												) : null,
											),
										),
									)}
									{item.featuredCards?.map((featuredCard) =>
										featuredCard.link?.href ? (
											<li key={featuredCard.id}>
												<AppLink
													href={featuredCard.link.href}
													openExternalInNewTab={featuredCard.link.newTab ?? false}
													tabIndex={-1}
												>
													{featuredCard.link.label}
												</AppLink>
											</li>
										) : null,
									)}
								</ul>
							)}
						</li>
					))}

				{/* CTA buttons for SEO */}
				{logInLink?.href && logInLink?.label ? (
					<li>
						<AppLink href={logInLink.href} tabIndex={-1}>
							{logInLink.label}
						</AppLink>
					</li>
				) : null}

				{primaryButtons?.map((primaryButton) =>
					primaryButton.href ? (
						<li key={primaryButton.id}>
							<AppLink href={primaryButton.href} tabIndex={-1}>
								{primaryButton.label}
							</AppLink>
						</li>
					) : null,
				)}

				{dropdownItem?.links?.map((oneLink) =>
					oneLink.href ? (
						<li key={oneLink.id}>
							<AppLink
								href={oneLink.href}
								openExternalInNewTab={oneLink.newTab ?? false}
								tabIndex={-1}
							>
								{oneLink.title}
							</AppLink>
						</li>
					) : null,
				)}
			</ul>
		</nav>
	)
}
